var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.3801C7.18845 11.3801 7.34643 11.3163 7.47394 11.1888C7.60145 11.0613 7.66521 10.9033 7.66521 10.7149C7.66521 10.5264 7.60145 10.3684 7.47394 10.2409C7.34643 10.1135 7.18845 10.0499 7 10.0499C6.81155 10.0499 6.65357 10.1135 6.52606 10.2409C6.39855 10.3684 6.33479 10.5264 6.33479 10.7149C6.33479 10.9033 6.39855 11.0613 6.52606 11.1888C6.65357 11.3163 6.81155 11.3801 7 11.3801ZM6.38235 8.51356H7.61765V3.54068H6.38235V8.51356ZM4.08594 14.5L0 10.4178V4.58594L4.08224 0.5H9.91406L14 4.58224V10.4141L9.91776 14.5H4.08594Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.85ad3a4a70f4b11bddfac481473213ad.svg";
export { ForwardRef as ReactComponent };